<div class="search-container">
  <span class="p-float-label p-input-icon-right search-filter">
    <i class="pi pi-times" *ngIf="(searchText || '').length > 0" (click)="onClearSearch()"></i>
    <input pInputText id="searchText" [(ngModel)]="searchText" (keyup.enter)="onSearchText()" (blur)="onSearchText()" />
    <label htmlFor="searchText">{{ placeholder }}</label>
  </span>
  <p-button icon="pi pi-search" [style]="{ height: '100%' }" (onClick)="onSearchText()"></p-button>
</div>
